import { render, staticRenderFns } from "./AssignmentsOverview.vue?vue&type=template&id=8316be6c&scoped=true&"
import script from "./AssignmentsOverview.vue?vue&type=script&lang=js&"
export * from "./AssignmentsOverview.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsOverview.vue?vue&type=style&index=0&id=8316be6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8316be6c",
  null
  
)

export default component.exports